import { ArrowDown, ArrowUp } from 'lucide-react';
import type { Column, SortDirection, TableSort } from './table-types.ts';
import styles from './DataTable.module.css';

const ARIA_SORT: Readonly<Record<SortDirection, 'ascending' | 'descending'>> = {
  asc: 'ascending',
  desc: 'descending',
};

const nextDirection = (sort: TableSort, key: string): SortDirection =>
  sort.key === key && sort.direction === 'asc' ? 'desc' : 'asc';

export const HeaderCell = <Row,>({ column, sort }: { column: Column<Row>; sort: TableSort | undefined }) => {
  if (column.action)
    return (
      <th scope="col" className={styles['action']}>
        {column.header}
      </th>
    );
  const sortKey = column.sortKey;
  const numeric = column.numeric ? styles['numeric'] : undefined;
  if (sortKey === undefined || sort === undefined)
    return (
      <th scope="col" className={numeric}>
        {column.header}
      </th>
    );
  const current = sort.key === sortKey;
  const Arrow = sort.direction === 'asc' ? ArrowUp : ArrowDown;
  return (
    <th scope="col" className={numeric} aria-sort={current ? ARIA_SORT[sort.direction] : 'none'}>
      <button
        type="button"
        className={[styles['sort'], current ? styles['sorted'] : ''].join(' ')}
        onClick={() => {
          sort.onChange(sortKey, nextDirection(sort, sortKey));
        }}
      >
        {column.header}
        {current ? <Arrow size={14} aria-hidden="true" /> : null}
      </button>
    </th>
  );
};
